/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash c971e80ed071b635f208fbc73d5eb449 */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RemoveEventAttendanceInput = {
    clientMutationId?: string | null | undefined;
    eventId: string;
    userId?: string | null | undefined;
};
export type EventAttendButtonSingleRemoveAttendanceMutationVariables = {
    input: RemoveEventAttendanceInput;
};
export type EventAttendButtonSingleRemoveAttendanceMutationResponse = {
    readonly removeEventAttendance: {
        readonly event: {
            readonly " $fragmentRefs": FragmentRefs<"EventItemNew_event" | "EventScreenNewMobile_event" | "EventScreenNewDesktop_event" | "EventScreenAttendeesDialogContent_event">;
        } | null;
    } | null;
};
export type EventAttendButtonSingleRemoveAttendanceMutation = {
    readonly response: EventAttendButtonSingleRemoveAttendanceMutationResponse;
    readonly variables: EventAttendButtonSingleRemoveAttendanceMutationVariables;
};



/*
mutation EventAttendButtonSingleRemoveAttendanceMutation(
  $input: RemoveEventAttendanceInput!
) {
  removeEventAttendance(input: $input) {
    event {
      ...EventItemNew_event
      ...EventScreenNewMobile_event
      ...EventScreenNewDesktop_event
      ...EventScreenAttendeesDialogContent_event
      id
    }
  }
}

fragment EventAttendButtonHybridAttend_event on Event {
  rowId
  prettyUrl
  hasVenue
  hasExternalUrl
  myAttendance {
    status
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventAttendButtonNew_event on Event {
  rowId
  prettyUrl
  endAt
  hasExternalUrl
  hasVenue
  myAttendance {
    status
    userId
    id
  }
  owner {
    __typename
    ... on Guild {
      slugId
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...EventAttendButtonSingleAttend_event
  ...EventAttendButtonHybridAttend_event
}

fragment EventAttendButtonSingleAttend_event on Event {
  rowId
  prettyUrl
  hasVenue
  hasExternalUrl
  myAttendance {
    status
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventAttendeesOverlap_eventAttendees on EventAttendeesConnection {
  edges {
    node {
      user {
        firstName
        lastName
        ...UserPrimaryPhotoNew_user_w8mmD
        id
      }
      id
    }
    cursor
  }
}

fragment EventItemEventCardPhoto_event on Event {
  prettyUrl
  visibility
  coverPhoto {
    rowId
    contentType
    id
  }
}

fragment EventItemNew_event on Event {
  name
  startAt
  prettyUrl
  hasExternalUrl
  hasVenue
  visibility
  coverPhoto {
    rowId
    id
  }
  eventOwner: owner {
    __typename
    ... on Guild {
      name
      slugId
      primaryPhoto {
        rowId
        id
      }
      ...GuildPrimaryPhotoNew_guild
    }
    ... on User {
      firstName
      lastName
      slugId
      ...UserPrimaryPhotoNew_user_4oAvFi
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  attendeesByRelevance: eventAttendeesByRelevance(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL]}}, first: 5) {
    totalCount
    ...EventAttendeesOverlap_eventAttendees
  }
  attendingCount: eventAttendees(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL]}}) {
    totalCount
  }
  waitingCount: eventAttendees(condition: {status: WAITING_IN_PERSON}) {
    totalCount
  }
  ...EventAttendButtonNew_event
  ...EventItemEventCardPhoto_event
  ...EventItemPresentations_event
}

fragment EventItemPresentations_event on Event {
  eventItemPresentations: presentations {
    edges {
      node {
        title
        rowId
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhotoNew_user_w8mmD
          id
        }
        id
      }
      cursor
    }
  }
}

fragment EventScreenAttendCard_event on Event {
  slug
  startAt
  endAt
  eventAttendeesByRelevance(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL, WAITING_IN_PERSON]}}, first: 5) {
    totalCount
    ...EventAttendeesOverlap_eventAttendees
  }
  attendingCount: eventAttendees(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL]}}) {
    totalCount
  }
  waitingCount: eventAttendees(condition: {status: WAITING_IN_PERSON}) {
    totalCount
  }
  myAttendance {
    status
    id
  }
  ...EventAttendButtonNew_event
}

fragment EventScreenAttendeesDialogAttendeeList_eventAttendees on EventAttendeesConnection {
  edges {
    node {
      user {
        slugId
        firstName
        lastName
        ...UserPrimaryPhotoNew_user_2NgS5p
        id
      }
      id
    }
    cursor
  }
}

fragment EventScreenAttendeesDialogContent_event on Event {
  eventAttendees(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL, WAITING_IN_PERSON]}}) {
    totalCount
  }
  ...EventScreenAttendeesDialogInPersonAttendees_event
  ...EventScreenAttendeesDialogWaitingInPersonAttendees_event
  ...EventScreenAttendeesDialogOnlineAttendees_event
  ...EventScreenAttendeesDialogNotAttending_event
}

fragment EventScreenAttendeesDialogInPersonAttendees_event on Event {
  attendeeLimit
  inPersonAttendees: eventAttendeesByRelevance(first: 10, condition: {status: ATTENDING_IN_PERSON}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendeesDialogAttendeeList_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenAttendeesDialogNotAttending_event on Event {
  notAttending: eventAttendeesByRelevance(first: 10, condition: {status: NOT_ATTENDING}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendeesDialogAttendeeList_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  owner {
    __typename
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  id
}

fragment EventScreenAttendeesDialogOnlineAttendees_event on Event {
  onlineAttendees: eventAttendeesByRelevance(first: 10, condition: {status: ATTENDING_VIRTUAL}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendeesDialogAttendeeList_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenAttendeesDialogWaitingInPersonAttendees_event on Event {
  attendeeLimit
  waitingAttendees: eventAttendeesByRelevance(first: 10, condition: {status: WAITING_IN_PERSON}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendeesDialogAttendeeList_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenDateTime_event on Event {
  startAt
  endAt
  timeZone
}

fragment EventScreenJoin_event on Event {
  hasVenue
  hasExternalUrl
  externalUrl
  myAttendance {
    status
    id
  }
  venue {
    name
    entryInstructions
    address {
      addressLine1
      addressLine2
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventScreenMap_event on Event {
  hasVenue
  venue {
    name
    address {
      addressLine1
      addressLine2
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
  seoVenue {
    address {
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
}

fragment EventScreenNewCoverPhoto_event on Event {
  rowId
  prettyUrl
  visibility
  coverPhoto {
    rowId
    contentType
    id
  }
}

fragment EventScreenNewDesktop_event on Event {
  name
  description
  prettyUrl
  startAt
  endAt
  hasVenue
  hasExternalUrl
  seoVenue {
    address {
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
  ...EventScreenNewCoverPhoto_event
  ...EventScreenDateTime_event
  ...EventScreenOwner_event
  ...EventScreenSettingsButton_event
  ...EventScreenJoin_event
  ...EventScreenPresentations_event
  ...EventScreenAttendCard_event
  ...EventScreenMap_event
}

fragment EventScreenNewMobile_event on Event {
  name
  description
  prettyUrl
  startAt
  endAt
  hasVenue
  hasExternalUrl
  seoVenue {
    address {
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
  ...EventScreenNewCoverPhoto_event
  ...EventScreenSettingsButton_event
  ...EventScreenDateTime_event
  ...EventScreenOwner_event
  ...EventScreenJoin_event
  ...EventScreenPresentations_event
  ...EventScreenAttendCard_event
  ...EventScreenMap_event
}

fragment EventScreenOwner_event on Event {
  owner {
    __typename
    ... on Guild {
      name
      slugId
      primaryPhoto {
        rowId
        id
      }
      ...GuildPrimaryPhotoNew_guild
    }
    ... on User {
      firstName
      lastName
      slugId
      ...UserPrimaryPhotoNew_user_1WCpC0
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventScreenPresentations_event on Event {
  presentations {
    edges {
      node {
        rowId
        prettyUrl
        title
        description
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhotoNew_user_4ajbLW
          id
        }
        id
      }
      cursor
    }
  }
}

fragment EventScreenSettingsButton_event on Event {
  id
  prettyUrl
  visibility
  hasVenue
  hasExternalUrl
  description
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment GuildPrimaryPhotoNew_guild on Guild {
  rowId
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhotoNew_user_1WCpC0 on User {
  rowId
  gravatarImageUrl(size: 80)
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhotoNew_user_2NgS5p on User {
  rowId
  gravatarImageUrl(size: 64)
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhotoNew_user_4ajbLW on User {
  rowId
  gravatarImageUrl(size: 96)
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhotoNew_user_4oAvFi on User {
  rowId
  gravatarImageUrl(size: 56)
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhotoNew_user_w8mmD on User {
  rowId
  gravatarImageUrl(size: 48)
  primaryPhoto {
    rowId
    contentType
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v15 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "status": {
      "in": [
        "ATTENDING_IN_PERSON",
        "ATTENDING_VIRTUAL"
      ]
    }
  }
},
v16 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v18 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "size",
        "value": 48
      }
    ],
    "kind": "ScalarField",
    "name": "gravatarImageUrl",
    "storageKey": "gravatarImageUrl(size:48)"
  },
  (v13/*: any*/),
  (v5/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = [
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v19/*: any*/)
    ],
    "storageKey": null
  }
],
v21 = [
  (v17/*: any*/)
],
v22 = {
  "kind": "Literal",
  "name": "condition",
  "value": {
    "status": "WAITING_IN_PERSON"
  }
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v31 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "status": {
      "in": [
        "ATTENDING_IN_PERSON",
        "ATTENDING_VIRTUAL",
        "WAITING_IN_PERSON"
      ]
    }
  }
},
v32 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v33 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "ATTENDING_IN_PERSON"
    }
  },
  (v32/*: any*/)
],
v34 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v19/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "size",
                    "value": 64
                  }
                ],
                "kind": "ScalarField",
                "name": "gravatarImageUrl",
                "storageKey": "gravatarImageUrl(size:64)"
              },
              (v13/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v35 = [
  "condition"
],
v36 = [
  (v22/*: any*/),
  (v32/*: any*/)
],
v37 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "ATTENDING_VIRTUAL"
    }
  },
  (v32/*: any*/)
],
v38 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "NOT_ATTENDING"
    }
  },
  (v32/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventAttendButtonSingleRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventItemNew_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewMobile_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewDesktop_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenAttendeesDialogContent_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventAttendButtonSingleRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": "eventOwner",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": 56
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "gravatarImageUrl",
                        "storageKey": "gravatarImageUrl(size:56)"
                      },
                      (v13/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "attendeesByRelevance",
                "args": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}},first:5)"
              },
              {
                "alias": "attendingCount",
                "args": [
                  (v15/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
              },
              {
                "alias": "waitingCount",
                "args": [
                  (v22/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"WAITING_IN_PERSON\"})"
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "membershipLevel",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMe",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": 80
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "gravatarImageUrl",
                        "storageKey": "gravatarImageUrl(size:80)"
                      },
                      (v13/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "eventItemPresentations",
                "args": null,
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v4/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": (v18/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "seoVenue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entryInstructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v23/*: any*/),
                          (v26/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "size",
                                    "value": 96
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "gravatarImageUrl",
                                "storageKey": "gravatarImageUrl(size:96)"
                              },
                              (v13/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v31/*: any*/),
                  (v16/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\"]}},first:5)"
              },
              {
                "alias": null,
                "args": [
                  (v31/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\"]}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attendeeLimit",
                "storageKey": null
              },
              {
                "alias": "inPersonAttendees",
                "args": (v33/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:10)"
              },
              {
                "alias": "inPersonAttendees",
                "args": (v33/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogInPersonAttendees_event_inPersonAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "waitingAttendees",
                "args": (v36/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"WAITING_IN_PERSON\"},first:10)"
              },
              {
                "alias": "waitingAttendees",
                "args": (v36/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogWaitingInPersonAttendees_event_waitingAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "onlineAttendees",
                "args": (v37/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:10)"
              },
              {
                "alias": "onlineAttendees",
                "args": (v37/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogOnlineAttendees_event_onlineAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "notAttending",
                "args": (v38/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"NOT_ATTENDING\"},first:10)"
              },
              {
                "alias": "notAttending",
                "args": (v38/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogNotAttending_event_notAttending",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1c9c41a9bba10aa16846169d3ac92b3bb3a210e2cc5f2c932a5e961a11f789ed",
    "metadata": {},
    "name": "EventAttendButtonSingleRemoveAttendanceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '5bb26eeabe29b79dd65e413c53a96a14';
export default node;
